import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useOrders = (page = 1, term = null, type = null, status = null) => useQuery({ queryKey: ['orders', page, term, type, status], queryFn: async () => {
    const callback = await API.get(`/orders?page=${page}${term ? `&term=${term}` : ''}${type ? `&type=${type}` : ''}${status ? `&status=${status}` : ''}`)
    return callback?.data
}, staleTime: 1000 * 60})

export default useOrders